const BYTES_PER_KB = 1024;

export const formatTrafficBytes = (value: number | null | undefined): string => {
  const bytes = Number(value || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) return '0.00 KB';
  const kb = bytes / BYTES_PER_KB;
  if (kb < BYTES_PER_KB) return `${kb.toFixed(2)} KB`;
  const mb = kb / BYTES_PER_KB;
  if (mb < BYTES_PER_KB) return `${mb.toFixed(2)} MB`;
  const gb = mb / BYTES_PER_KB;
  if (gb < BYTES_PER_KB) return `${gb.toFixed(2)} GB`;
  return `${(gb / BYTES_PER_KB).toFixed(2)} TB`;
};

export const formatTrafficRate = (value: number | null | undefined): string =>
  `${formatTrafficBytes(value)}/s`;
